import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 13.13a2.53 2.53 0 0 0-.76-1.33 2.57 2.57 0 0 0-1.37-.8 2.34 2.34 0 0 0-1.2.09 3.1 3.1 0 0 0-.8.4l-.22.18a.2.2 0 0 0-.06.06L5 15.36l-3.83 3.82a.58.58 0 0 0-.17.41v2.84a.57.57 0 0 0 .57.57h2.84a.54.54 0 0 0 .4-.17l7.39-7.39.06-.06c.06-.06.11-.13.17-.22.179-.243.317-.513.41-.8a2.36 2.36 0 0 0 .16-1.23m-8.82 8.73h-2v-2l6.25-6.25 2 2zM11.79 14a1.6 1.6 0 0 1-.25.49l-.11.14-.17.16-2-2 .17-.17.14-.11q.232-.164.5-.26.195-.065.4-.07h.21c.293.063.56.217.76.44.219.2.372.461.44.75a1.1 1.1 0 0 1-.09.63",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m22.71 8.29-7-7A1 1 0 0 0 15 1H8a3 3 0 0 0-2.12.88A3 3 0 0 0 5 4v6.53a1 1 0 1 0 2 0V4a1 1 0 0 1 .29-.71A1 1 0 0 1 8 3h6v6a1 1 0 0 0 1 1h6v10a1 1 0 0 1-1 1h-9.61a1 1 0 0 0 0 2H20a3 3 0 0 0 3-3V9a1 1 0 0 0-.29-.71M16 8V4.41L19.59 8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }